import Vue from 'vue'
import VueRouter from 'vue-router'
import lanhu_chengshigaikuang from '../views/lanhu_chengshigaikuang/index.vue'
import lanhu_shahegaojiaoyuan from '../views/lanhu_shahegaojiaoyuan/index.vue'
import lanhu_chanyefazhan from '../views/lanhu_chanyefazhan/index.vue'
import lanhu_quweiyoushi from '../views/lanhu_quweiyoushi/index.vue'
import lanhu_changpingxinchengdongqu from '../views/lanhu_changpingxinchengdongqu/index.vue'
import lanhu_shujutongji from '../views/lanhu_shujutongji/index.vue'
import lanhu_zhongdianyuanqu from '../views/lanhu_zhongdianyuanqu/index.vue'
import lanhu_shengminggu from '../views/lanhu_shengminggu/index.vue'
import lanhu_nengyuangu from '../views/lanhu_nengyuangu/index.vue'
import lanhu_yingshanghuanjing from '../views/lanhu_yingshanghuanjing/index.vue'
import lanhu_liangqugaikuang from '../views/lanhu_liangqugaikuang/index.vue'

Vue.use(VueRouter)

const routes = [
    {
    path: '/',
    redirect: "/lanhu_chengshigaikuang",
	meta: { title: '城市概况' }
  },
  {
    path: '/lanhu_chengshigaikuang',
    name: 'lanhu_chengshigaikuang',
    component: lanhu_chengshigaikuang,
	meta: { title: '城市概况' }
  },
  {
    path: '/lanhu_shahegaojiaoyuan',
    name: 'lanhu_shahegaojiaoyuan',
    component: lanhu_shahegaojiaoyuan,
	meta: { title: '沙河高教园' }
  },
  {
    path: '/lanhu_chanyefazhan',
    name: 'lanhu_chanyefazhan',
    component: lanhu_chanyefazhan,
	meta: { title: '产业发展' }
  },
  {
    path: '/lanhu_quweiyoushi',
    name: 'lanhu_quweiyoushi',
    component: lanhu_quweiyoushi,
	meta: { title: '区位优势' }
  },
  {
    path: '/lanhu_changpingxinchengdongqu',
    name: 'lanhu_changpingxinchengdongqu',
    component: lanhu_changpingxinchengdongqu,
	meta: { title: '昌平新城东区' }
  },
  {
    path: '/lanhu_shujutongji',
    name: 'lanhu_shujutongji',
    component: lanhu_shujutongji,
	meta: { title: '数据统计' }
  },
  {
    path: '/lanhu_zhongdianyuanqu',
    name: 'lanhu_zhongdianyuanqu',
    component: lanhu_zhongdianyuanqu,
	meta: { title: '重点园区' }
  },
  {
    path: '/lanhu_shengminggu',
    name: 'lanhu_shengminggu',
    component: lanhu_shengminggu,
	meta: { title: '生命谷' }
  },
  {
    path: '/lanhu_nengyuangu',
    name: 'lanhu_nengyuangu',
    component: lanhu_nengyuangu,
	meta: { title: '能源谷' }
  },
  {
    path: '/lanhu_yingshanghuanjing',
    name: 'lanhu_yingshanghuanjing',
    component: lanhu_yingshanghuanjing,
	meta: { title: '营商环境' }
  },
  {
    path: '/lanhu_liangqugaikuang',
    name: 'lanhu_liangqugaikuang',
    component: lanhu_liangqugaikuang,
	meta: { title: '两区概况' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
